// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.multi-line-header .MuiDataGrid-columnHeaderTitle {
  display: flex;
  justify-content: center;
  white-space: pre-wrap;
  text-align: center;
  line-height: 1.2em;
}

  `, "",{"version":3,"sources":["webpack://./src/Charts/ResultsTableMonitoring.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":["\n.multi-line-header .MuiDataGrid-columnHeaderTitle {\n  display: flex;\n  justify-content: center;\n  white-space: pre-wrap;\n  text-align: center;\n  line-height: 1.2em;\n}\n\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
